<template>
    <div class="gradient uk-padding uk-padding-remove-top">   
        <slot></slot>
        <div class="uk-text-center btn-extra-large-text">
            <div v-html="title"></div>
            <button v-if="showNext" 
                    @click="nextFrame(frameNum+1)" 
                    class="uk-button uk-button-primary navigate-frame-btn">Next<span uk-icon="icon: chevron-right; ratio: 2"></span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "this is the title"
        },
        frameNum:{
            type: Number,
            default: 0
        },
        nextFrame:{
            type: Function
        },
        previousFrame: {
            type: Function
        },
        showNext: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        previousFrameQuestion(){
            this.previousFrame(this.frameNum-1)
        },
        nextFrameQuestion(){
            this.nextFrame(this.frameNum+1)
        },
    }
}
</script>

<style>
    .gradient {
            background: white;
    }
</style>


